// Chassis design-system tokens for the PE serving-layer screens.
//
// branding.ts is the source of truth for PE brand colors (forest green / gold).
// Tailwind's config carries no custom tokens, so screens use Tailwind utilities
// for layout and these brand values (inline) for accents — no new UI framework.

import { brandingConfig } from "../../../../config/branding";

export const chassis = {
  accent: brandingConfig.colors.accent, // forest green #3b5839
  accentText: brandingConfig.colors.btnPrimaryText, // #fff
  icon: brandingConfig.colors.iconColor, // gold #976634
  textPrimary: brandingConfig.colors.textPrimary,
  textSecondary: brandingConfig.colors.textSecondary,
  background: brandingConfig.colors.background, // #fafafa
};

export const TIER_LABELS: Record<string, string> = {
  T1: "Tier 1",
  T2: "Tier 2",
  T3: "Tier 3",
  T4: "Tier 4",
};

export const LANG_LABELS: Record<string, string> = {
  en: "English",
  es: "Español",
};
